export const LOYALTY_REWARDS_POINTS_TEXT_ID = 'crownsApplied';
